<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { categoryService } from "../../../../services/inventoryservice/category.service";
import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Category List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      categoryData: {},
      typeData: {},
      fetchingStats: false,
      title: "Category List",

    };
  },
  mounted() {

    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      categoryService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.categoryData = response;
        });
    },

    deleted: function(id) {
      categoryService.remove(id)
        .then(response => {
        
          // this.categoryData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "category-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'category-add'}" :title="$t('category.text')" />
    <List v-bind:dataList="categoryData" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[ `code: ${$t('category.code')}`, `name: ${$t('category.name')}`, `name_en: ${$t('category.name-en')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'category-edit'}"
          v-bind:filter="{
            search: ['categories.code', 'categories.name', 'categories.name_en'],
            dropdown: []
          }"
          
    />      
  </Layout>
</template>